import { render, staticRenderFns } from "./FormCaptionSection.vue?vue&type=template&id=b3b260be&"
import script from "./FormCaptionSection.vue?vue&type=script&lang=js&"
export * from "./FormCaptionSection.vue?vue&type=script&lang=js&"
import style0 from "./FormCaptionSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports